/**
 * Product Link Box
 * A responsive and adaptive es-module
 *
 * @module feature-product-link-box
 * @version 1.0.0
 * @author Tim Vermaelen, tim.vermaelen@blastic.com
 */

const cfg = {
  cache: {
    container: '[data-dm="component.product-link-box"]',
  },
  events: {
    resize: 'resize',
    ready: 'DOMContentLoaded',
  },
  options: {
    mode: {
      horizontal: 'horizontal',
      vertical: 'vertical',
    },
    breakpoints: {
      xs: 360,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
};

const containers = document.querySelectorAll(cfg.cache.container);

function init() {
  if (containers) {
    bindEvents();
    toggleMode();
  }
}

function bindEvents() {
  window.addEventListener(cfg.events.resize, toggleMode);
}

/**
 * Toggle between horizontal & vertical mode
 * Toggle adaptive breakpoint to override modes in narrow parents
 */
function toggleMode() {
  containers.forEach((element) => {
    const el = element;
    const w = el.parentElement.clientWidth;
    const { sm } = cfg.options.breakpoints;
    const { horizontal, vertical } = cfg.options.mode;
    let bp = 'xs';

    el.dataset.mode = w > sm ? horizontal : vertical;

    Object.keys(cfg.options.breakpoints).forEach((key) => {
      bp = w > cfg.options.breakpoints[key] ? key : bp;
    });

    el.dataset.adaptive = bp;
  });
}

// on dom ready
document.addEventListener(cfg.events.ready, () => {
  init();
});
